export type Row = {
  kind: string;
  credits: number;
  job_kind: string | null;
};

const prettyJob = (k: string | null) => (k ? k.replace(/_/g, " ") : "Other");

export function summarize(rows: readonly Row[]): {
  granted: number;
  used: number;
  remaining: number;
  byJob: { job: string; credits: number }[];
} {
  let granted = 0;
  let used = 0;
  const jobMap = new Map<string, number>();

  for (const r of rows) {
    if (r.credits > 0) {
      // Counts monthly_grant, topup_purchase, refund, positive adjustments
      granted += r.credits;
    } else if (r.kind === "consumption") {
      const cost = Math.abs(r.credits);
      used += cost;
      const job = prettyJob(r.job_kind);
      jobMap.set(job, (jobMap.get(job) ?? 0) + cost);
    } else {
      // Negative non-consumption (e.g. grant reversal) — count against granted
      granted += r.credits;
    }
  }

  const byJob = [...jobMap.entries()]
    .map(([job, credits]) => ({ job, credits }))
    .sort((a, b) => b.credits - a.credits);

  // Top 5 + bucketed "Other"
  let top: { job: string; credits: number }[] = byJob;
  if (byJob.length > 5) {
    const head = byJob.slice(0, 5);
    const tail = byJob.slice(5).reduce((s, x) => s + x.credits, 0);
    top = [...head, { job: "Other", credits: tail }];
  }

  return {
    granted,
    used,
    remaining: Math.max(0, granted - used),
    byJob: top,
  };
}
